import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colorGrid } from 's2s-themes';

const KeypadItemContainer = styled.div`
  font-family: Poppins;
  align-items: center;
  background-color: ${colorGrid.gray0};
  border : 1px solid transparent;
  border-radius : 2px;
  color: ${colorGrid.gray9};
  cursor: pointer;
  display : flex;
  flex-direction: column;
  height : 64px;
  justify-content: center;
  justify-self : center;
  outline: none;
  padding : 0px;
  width : 96px;

  // styles to prevent highlighting of text when mouse drags over keys
  -webkit-touch-callout : none;
  -moz-touch-callout : none;
  -ms-touch-callout : none;
  touch-callout : none;

  -webkit-user-select : none;
  -moz-user-select : none;
  -ms-user-select : none;
  user-select : none;

  &:hover {
    border-radius: 4px;
    background-color: rgba(36, 57, 145, 0.04);
  }
`;

const ContentArea = styled.div`
  align-items : center;
  display: flex;
  min-height: 40px;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  margin: 0;
  width: 100%;
`;

const KeyValue = styled.div`
  font-size: 24px;
  font-weight: 400;
  padding-top: 8px
  outline: none;
  color: #243991;
`;

const KeyString = styled.div`
  font-weight: 500;
  font-size: 10px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.1px;
  color: #7F888F;
`;

const  KeypadItem = (props) => {

  const handleMouseDown = () => {
    props.cbMouseDown(props.keyValue);
  };

  const handleMouseUp = () => {
    props.cbMouseUp(props.keyValue);
  };

  const handleMouseLeave = () => {
    props.cbMouseLeave(props.keyValue);
  };

  return (
    <KeypadItemContainer
      href="#"
      key={'keypadItem-' + props.keyValue}
      className={'keypadItem-' + props.keyValue}
      aria-label={'Key' + props.keyValue + props.keyString}
      tabIndex="0"
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
    >
      <ContentArea className="ContentArea">
        <KeyValue className={"keyValue-" + props.keyValue} >
          {props.keyValue}
        </KeyValue>
        <KeyString className={"keyString-" + props.keyString} >
          {props.keyString}
        </KeyString>
      </ContentArea>
    </KeypadItemContainer>
  );
};

KeypadItem.propTypes = {
  keyString: PropTypes.string,
  keyValue: PropTypes.string.isRequired,
  cbMouseDown: PropTypes.func.isRequired,
  cbMouseUp: PropTypes.func.isRequired,
  cbMouseLeave: PropTypes.func.isRequired
};

export default KeypadItem;
